export default __webpack_public_path__ + "static/media/LoginPageIcon.82610e1e.png";